import { useState } from 'react';
import { ActivityV3Todo } from 'src/components/activityv3/ActivityV3Todo';
import BottomSheetListSelection from 'src/components/bottomSheet/BottomSheetListSelection';
import { BackButton, TopNavbar } from 'src/components/common';
import { Typography } from 'src/components/common/Typography';
import SVGIcon from 'src/components/icon/SVGIcon';
import { ResponseActivityV3ByStudentDto } from 'src/generated/model';
import { getUnsubmittedSessionsAsSeparateItems } from 'src/util/activityv3';

interface ActivityTodoPageProps {
  data: ResponseActivityV3ByStudentDto[];
}

export function ActivityTodoPage({ data }: ActivityTodoPageProps) {
  const [sortType, setSortType] = useState<'DESC' | 'ASC'>('DESC');
  const [isActivityBottomSheetOpen, setIsActivityBottomSheetOpen] = useState(false);

  // 미제출 차시가 있는 활동만 필터링
  const activitiesWithUnsubmittedSessions = getUnsubmittedSessionsAsSeparateItems(data, sortType);

  const handleSortChange = (value: 'ASC' | 'DESC') => {
    setSortType(value);
    setIsActivityBottomSheetOpen(false);
  };

  return (
    <div className="flex h-full flex-col">
      <TopNavbar title="나의 할 일" left={<BackButton />} />

      <main className="flex flex-col gap-4 px-5 py-4">
        <BottomSheetListSelection
          isOpen={isActivityBottomSheetOpen}
          onClose={() => setIsActivityBottomSheetOpen(false)}
        >
          {[
            { id: 0, value: 'ASC', text: '마감기한 순' },
            { id: 1, value: 'DESC', text: '최신 생성 순' },
          ].map((item, index) => {
            const isSelected = sortType === item.value;
            return (
              <div key={index} className="flex flex-row items-center justify-between py-4">
                <Typography
                  variant={isSelected ? 'title3' : 'body1'}
                  className={isSelected ? 'font-semibold text-primary-orange-800' : 'text-primary-gray-700'}
                  onClick={() => handleSortChange(item.value as 'ASC' | 'DESC')}
                >
                  {item.text}
                </Typography>
                {isSelected && <SVGIcon.Check color="orange800" size={20} />}
              </div>
            );
          })}
        </BottomSheetListSelection>
        <div
          className="inline-flex w-fit cursor-pointer flex-row items-center justify-between gap-2 rounded-md border border-primary-gray-200 bg-white px-2.5 py-1.5"
          onClick={() => setIsActivityBottomSheetOpen(true)}
        >
          <Typography variant="body3" className="font-medium text-primary-gray-700">
            {sortType === 'DESC' ? '최신 생성 순' : '마감기한 순'}
          </Typography>
          <SVGIcon.Arrow color="gray700" size={16} rotate={270} />
        </div>

        {activitiesWithUnsubmittedSessions.length > 0 ? (
          <div className="flex flex-col gap-4">
            {activitiesWithUnsubmittedSessions.map((activity, index) => (
              <ActivityV3Todo key={index} activityv3={activity} />
            ))}
          </div>
        ) : (
          <></>
        )}
      </main>
    </div>
  );
}
